import { useQuery } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { getNonBookableLaundrySlots } from './api';
import { mapDataForClient } from './mapData';

// Relevant for apartment resource only
export const NON_BOOKABLE_SLOTS = 'nonBookableSlots';

export function useNonBookableSlots(resourceId) {
  const tenantId = getTenantIDBasedOnURL();

  const { data, isLoading, isFetching, isError } = useQuery(
    [NON_BOOKABLE_SLOTS, tenantId, resourceId],
    () => getNonBookableLaundrySlots(resourceId),
    {
      enabled: !!resourceId,
    },
  );

  const processedData = data?.bookings 
    ? mapDataForClient(data.bookings) 
    : { filteredBookings: [], fullyBookedDates: [], bookedSlotsByDate: {} };

  return {
    nonBookableSlots: data?.bookings,
    fullyBookedDates: processedData.fullyBookedDates,
    bookedSlotsByDate: processedData.bookedSlotsByDate,
    filteredBookings: processedData.filteredBookings,
    isLoading,
    isFetching,
    isError,
  };
}
